<template>
  <div class="tab-content timeline-multi">
    <div class="timeline-left">
      <h6>{{$t('INDENT_INDENT_TIMELINE')}}</h6>
      <timeline class="timeline-default">
        <timeline-item
          v-for="(activity, index) in getTimeline"
          :key="index"
          :timestamp="getDate(activity.value)"
          placement="top"
          :class="getDotColor(activity)">
          <h4>{{timelineLabels[activity.type] && $t(timelineLabels[activity.type].tlabel)}}
            <span v-if="activity.gate"> - {{activity.gate}}</span>
          </h4>
          <p v-if="activity.name">{{activity.name}}</p>
          <p v-if="activity.city">{{activity.city}}</p>
          <p v-if="activity.message">{{activity.message}}</p>
        </timeline-item>
      </timeline>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { timelineLabels } from '@/constants/indentConstants';

export default {
  props: {
    timeline: {
      type: Array,
      default: () => [],
    },
    timeFormat: {
      type: String,
      default: 'dd-MM-yyyy | hh:mm A',
    },
  },
  data() {
    return {
      timelineLabels,
    };
  },
  computed: {
    getTimeline() {
      const item = this.timeline.filter(tl => tl.value);
      return item.sort((a, b) => new Date(a.value) - new Date(b.value));
    },
  },
  methods: {
    getDotColor(activity) {
      const redDotEvents = ['not_delivered'];
      return redDotEvents.includes(activity.type) ? 'dot-red' : 'dot-purple';
    },
    getDate(date) {
      return moment(date).format(this.timeFormat);
    },
  },
};
</script>
